import JSONAPISerializer from '@ember-data/serializer/json-api';
import { isPresent } from '@ember/utils';
import nestedCamelizer from 'invite-sign/utils/nested-camelizer';

export default class FlowSerializer extends JSONAPISerializer {
  normalize() {
    let normalized = super.normalize(...arguments);
    let {
      data: { attributes },
    } = normalized;
    if (isPresent(attributes.ipadLocalizedNames)) {
      attributes.ipadLocalizedNames = nestedCamelizer(attributes.ipadLocalizedNames);
    }
    return normalized;
  }
}
